import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTerm({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M11 6.25a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5zm0-6c.92 0 1.67.7 1.74 1.6l.01.15v2.5a.75.75 0 01-1.5.1V2a.25.25 0 00-.2-.24L11 1.75H2a.25.25 0 00-.24.2L1.75 2v11c0 .12.08.22.2.24l.05.01h3.2a.75.75 0 01.1 1.5H2c-.92 0-1.67-.7-1.74-1.6L.25 13V2c0-.92.7-1.67 1.6-1.74L2 .25h9zm0 7.5a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5zm0 1.04c.41 0 .75.34.75.75v1.15l.79.8a.75.75 0 11-1.06 1.05l-1.01-1.01a.75.75 0 01-.22-.53V9.54c0-.41.34-.75.75-.75zM6 6.25a.75.75 0 01.1 1.5H4a.75.75 0 01-.1-1.5H6zm3.05-3a.75.75 0 01.1 1.5H4a.75.75 0 01-.1-1.5h5.15z" />
    </svg>
  );
}

SvgBasicTerm.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTerm.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicTerm svgRef={ref} {...props} />);
export default ForwardRef;
